import { useSetPaymentVerificationToPendingMutation } from "~/queries/identity/users";
import { getPaymentDetails } from "~/service/payment";
import { PaymentFailureCodes, PaymentSuccessCodes } from "~/types/Payment";

const PAYMENT_AUTHORISED = PaymentSuccessCodes.Authorised;
const PAYMENT_CANCELLED = PaymentFailureCodes.Cancelled;
const PAYMENT_REFUSED = PaymentFailureCodes.Refused;

export default () => {
  const router = useRouter();
  const route = useRoute();
  const i18n = useI18n();
  const toast = useToast();
  const { mutateAsync: setPaymentVerificationToPendingAsync } =
    useSetPaymentVerificationToPendingMutation();

  const showMessageToUser = async (redirectResult: string) => {
    try {
      const response = await getPaymentDetails({
        details: { redirectResult },
      });

      if (!response) {
        return;
      }

      const { resultCode, refusalReasonCode } = response;
      const failureReason = refusalReasonCode || resultCode;

      const isPaymentFailure =
        !!refusalReasonCode ||
        resultCode === PAYMENT_CANCELLED ||
        resultCode === PAYMENT_REFUSED;

      if (isPaymentFailure) {
        toast.error(
          i18n.te(`payment.refusalReasonDescription.${failureReason}`)
            ? i18n.t(`payment.refusalReasonDescription.${failureReason}`)
            : i18n.t("payment.refusalReasonCode.unknown"),
          {
            timeout: 10000,
          },
        );
      } else if (resultCode === PAYMENT_AUTHORISED) {
        toast.success(i18n.t("myAccount.verify.modal.paymentScreen.success"), {
          timeout: 10000,
        });
        await setPaymentVerificationToPendingAsync();
      }
    } finally {
      router.replace({ path: route.path, query: {} });
    }
  };

  return {
    showMessageToUser,
  };
};
